import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import React from "react";

interface Props {
    open: boolean;
    title: string;
    description: React.ReactNode | string;
    onClose: (open: boolean) => void;
}

export default function DialogViewLimit(props: Props) {

    return (
        <Dialog open={props.open} onOpenChange={props.onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-left">
                        {props.title}
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    {props.description}
                </div>
            </DialogContent>
        </Dialog>
    );
}
